export default "/build/client/static/fonts/SoderbergSans-Black.woff2";